import { gql } from '@apollo/client';
import Fragments from '../fragments';

export const APPROVAL_TYPE_LEVEL_QUERY = gql`
  query approvalTypeLevel($approvalTypeId: Int!, $siteId: Int!, $approvalTypeLevelId: Int!, $approvalTypeLevelSiteId: Int!) {
    approvalTypeLevel(
      approvalTypeId: $approvalTypeId
      siteId: $siteId
      approvalTypeLevelId: $approvalTypeLevelId
      approvalTypeLevelSiteId: $approvalTypeLevelSiteId
    ) {
      ...approvalTypeLevelItem
      approvalTypeEmployees {
        ...approvalTypeEmployeeItem
      }
      approvalTypeUserGroups {
        ...approvalTypeUserGroupItem
      }
    }
  }
  ${Fragments.approvalTypeLevelItem}
  ${Fragments.approvalTypeEmployeeItem}
  ${Fragments.approvalTypeUserGroupItem}
`;

export const EMPLOYEES_QUERY = gql`
  query employees {
    employees {
      id
      name
    }
  }
`;
